import * as types from "../actionTypes/catalogWorkPlanAT";
import initialState from "./initialState";

export default function catalogWorkPlanReducer(
  state = initialState.catalogWorkPlans,
  action
) {
  switch (action.type) {
    case types.CREATE_CATALOG_WORKPLAN:
      return [...state, { ...action.course }];
    case types.UPDATE_CATALOG_WORKPLAN_SUCCESS:
      return state.map((course) =>
        course.id === action.course.id ? action.course : course
      );
    case types.LOAD_CATALOG_WORKPLAN_SUCCESS:
      return action.catalogWorkPlans;
    case types.DELETE_CATALOG_WORKPLAN_OPTIMISTIC:
      return state.filter((course) => course.id !== action.course.id);
    default:
      return state;
  }
}
